import { TextField } from "@mui/material";
import { useField } from "formik";
import React from "react";
import { FormFeedback, Input } from "reactstrap";
import { ColorTheme } from "../../../styles/color";
import { Text } from "../typography/Style";
import { LabelTextfieldContainer, StyledInputFormGroup } from "./Style";

const FormikInputField = ({
	name,
	fieldLabel,
	id,
	label,
	isMandatory,
	inputType,
	onTextfieldBlur,
	redesign,
	amplitudeData: _, // Extract this prop so that it isn't injected into the DOM
	...rest
}) => {
	const [field, { error, touched }, { setTouched }] = useField(name);
	if (inputType === "label") {
		return (
			<LabelTextfieldContainer>
				<Text mb={"6px"} size={"sm"} textweight={"medium"}>
					{fieldLabel}
				</Text>
				<TextField
					error={!!error && !!touched}
					onBlur={() => {
						setTouched(true);
					}}
					fullWidth
					label={""}
					variant={"outlined"}
					size={"small"}
					autoComplete="off"
					helperText={!!error && !!touched && error}
					{...field}
					{...rest}
				/>
			</LabelTextfieldContainer>
		);
	}
	if (inputType === "primary") {
		return (
			<>
				<TextField
					error={!!error && !!touched}
					onBlur={() => {
						setTouched(true);
					}}
					fullWidth
					label={label}
					variant={"outlined"}
					size={"small"}
					autoComplete="off"
					helperText={!!error && !!touched && error}
					{...field}
					{...rest}
				/>
			</>
		);
	}
	return (
		<StyledInputFormGroup
			redesign={redesign ? 1 : 0}
			onBlur={() => {
				setTouched(true);
				onTextfieldBlur?.();
			}}
		>
			{label && (
				<Text
					as="label"
					textcolor={ColorTheme.grayNeutral[700]}
					size={"sm"}
					textweight={"regular"}
				>
					{label}
					{isMandatory && (
						<>
							{" "}
							<span className="text-danger">*</span>
						</>
					)}
				</Text>
			)}
			<Input
				invalid={!!error && !!touched}
				name={name}
				id={id}
				{...field}
				{...rest}
			/>
			<FormFeedback>{error}</FormFeedback>
		</StyledInputFormGroup>
	);
};

export default FormikInputField;
